// extracted by mini-css-extract-plugin
export var item = "AnchorMenu-module--item--KZA9K";
export var spinAround = "AnchorMenu-module--spinAround--1SxSG";